// a quick and dirty function to strip function objects out of test assertions
export function stringifyCompare(obj: object) {
  return JSON.parse(JSON.stringify(obj));
}
